module.exports = __webpack_public_path__ + "media/images/jlp-features-sitter-profile-54d8247fcc2010c38c333574f703ed1f.svg";